"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var styledLayout_1 = require("../base/styledLayout");
var react_transition_group_1 = require("react-transition-group");
var TooltipDirection;
(function (TooltipDirection) {
    TooltipDirection["Top"] = "ty-tooltip-top";
    TooltipDirection["Bottom"] = "ty-tooltip-bottom";
})(TooltipDirection = exports.TooltipDirection || (exports.TooltipDirection = {}));
exports.Tooltip = function (_a) {
    var children = _a.children, content = _a.content, _b = _a.direction, direction = _b === void 0 ? "ty-tooltip-bottom" /* Bottom */ : _b, show = _a.show;
    var _c = React.useState(false), tooltipOn = _c[0], setTooltipOn = _c[1];
    var tooltipClassName = classnames_1.default('ty-tooltip', { 'ty-show': tooltipOn });
    var tooltipContentClassName = classnames_1.default('ty-tooltip-content', 'ty-bordered', direction);
    var tooltipRef = React.createRef();
    var parentRef = React.createRef();
    React.useEffect(function () {
        var parent = parentRef.current;
        var tooltip = tooltipRef.current;
        if (tooltipOn && parent && tooltip) {
            var rect = tooltip.getBoundingClientRect();
            var parentRect = parent.getBoundingClientRect();
            var parentHeight = parentRect.height;
            var width = rect.width;
            var verticalDistance = parentHeight + 15 + "px";
            if (direction === "ty-tooltip-bottom" /* Bottom */) {
                tooltip.style.top = verticalDistance;
            }
            else {
                tooltip.style.bottom = verticalDistance;
            }
            tooltip.style.left = "calc(50% - " + width / 2 + "px)";
        }
    }, [tooltipOn, direction]);
    React.useEffect(function () {
        if (!!show || show === false) {
            setTooltipOn(show);
        }
    }, [show]);
    return (React.createElement(styledLayout_1.StyledLayout, { className: tooltipClassName, position: "ty-relative" /* Relative */, forwardedRef: parentRef, onMouseEnter: function () { return setTooltipOn(true); }, onMouseLeave: function () { return setTooltipOn(false); } },
        React.createElement(styledLayout_1.StyledLayout, null, children),
        React.createElement(react_transition_group_1.CSSTransition, { classNames: "ty-transition-appear", timeout: 300, in: tooltipOn, unmountOnExit: true },
            React.createElement(styledLayout_1.StyledLayout, { className: tooltipContentClassName, position: "ty-absolute" /* Absolute */, backgroundColor: "ty-bg-white" /* White */, forwardedRef: tooltipRef },
                React.createElement(styledLayout_1.StyledLayout, { position: "ty-absolute" /* Absolute */, className: "ty-tooltip-padding" }),
                content))));
};
